import type { FC } from "react";

import { FeatureRowDomainCellText } from "app/pages/keyword-research/keyword-analysis/pages/serp-snapshot/StyledComponents";
import { CoreWebsiteCell } from "pro-features/components/core cells/src/CoreWebsiteCell/CoreWebsiteCell";
import { i18nFilter } from "app/filters/i18nFilter";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import type { SERPSnapshotCellProps } from "../../types";
import { ESERPMetaType } from "../../types";

export const SERPSnapshotDomainCell: FC<SERPSnapshotCellProps> = (props) => {
    const { row, onCellClick } = props;
    const onClick = (e) => {
        e.stopPropagation();
        onCellClick(e, row?.index);
    };
    //for future use to see the enrich rows
    if (row.type === ESERPMetaType.FEATURE) {
        return (
            <FlexRow
                justifyContent="flex-start"
                alignItems="center"
                onClick={onClick}
                className="enrich"
                style={{ cursor: "pointer" }}
            >
                <FeatureRowDomainCellText>
                    {i18nFilter()("keyword.research.serp.snapshot.table..domain.cell.domain.count", {
                        domains: row.records?.length,
                    })}
                </FeatureRowDomainCellText>
            </FlexRow>
        );
    } else {
        return (
            <CoreWebsiteCell
                domain={row.site}
                icon={row.favicon}
            />
        );
    }
};
